<template>
    <v-container class="admin-plans-container">
        <v-card class="admin-card" elevation="1">
            <div class="admin-header">
                <div class="admin-title-section">
                    <h1 class="admin-title">פרטי חבילות</h1>
                    <span class="admin-subtitle">ניהול חבילות המערכת</span>
                </div>
                <v-btn v-if="view === 'plans'" color="primary" class="add-plan-btn" elevation="1" @click="openCreateDIalog">
                    <v-icon left>mdi-plus</v-icon>
                    הוסף חבילה
                </v-btn>
            </div>

            <!-- תצוגה: החבילות עצמן, או מצב החבילות של כל המערכות (כמו בדף הסקרים) -->
            <div class="plans-seg" role="tablist" aria-label="תצוגה">
                <button type="button" role="tab" class="plans-seg__btn" :class="{ 'is-active': view === 'plans' }"
                    :aria-selected="view === 'plans' ? 'true' : 'false'" @click="view = 'plans'">
                    חבילות
                    <span class="plans-seg__count">{{ plans.length }}</span>
                </button>
                <button type="button" role="tab" class="plans-seg__btn" :class="{ 'is-active': view === 'stats' }"
                    :aria-selected="view === 'stats' ? 'true' : 'false'" @click="showStats">
                    מצב החבילות
                </button>
            </div>

            <div v-show="view === 'plans'">
            <div class="plans-count" v-if="plans.length > 0">
                <span>סה"כ {{ plans.length }} חבילות</span>
            </div>

            <v-row justify="center" style="box-shadow: inset 0px 1px 2px rgba(0, 0, 0, 0.1);">
                <v-col cols="auto" v-for="(item, index) in plans" :key="index">
                    <v-card class="plan-card" :class="{ 'plan-card-hidden': !item.show_to_user, 'ravkol-only-card': ['free', 'ravkol'].includes(item.bill_type) }" elevation="2">
                        <div class="plan-header" :class="index % 2 === 0 ? 'primary-plan' : 'secondary-plan'">
                            <h2 class="plan-name">{{ item.name }}</h2>
                            <div class="plan-price">
                                <span class="currency">₪</span>
                                <span class="amount">{{ item.price }}</span>
                            </div>
                            <!-- חבילה של סוכן: מוצגת רק למערכות של אותו סוכן -->
                            <div v-if="item.belong_to_agent" class="agent-badge">
                                <v-icon x-small>mdi-account-tie</v-icon>
                                <span>סוכן: {{ agentName(item) }}</span>
                            </div>
                            <!-- Rav-Kol Members Only Badge -->
                            <div v-if="['free', 'ravkol'].includes(item.bill_type)" class="ravkol-badge">
                                <v-chip small color="purple" text-color="white" class="ravkol-chip">
                                    <v-icon small left>mdi-account-star</v-icon>
                                    חינמית
                                </v-chip>
                            </div>
                        </div>

                        <div class="plan-body">
                            <div class="plan-features">
                                <div class="feature-item">
                                    <v-icon :color="index % 2 === 0 ? '#0d2c6d' : '#fdbd29'"
                                        class="feature-icon">mdi-account-group</v-icon>
                                    <div class="feature-text">
                                        <span class="feature-value">{{ item.contacts }}</span>
                                        <span class="feature-label">אנשי קשר</span>
                                    </div>
                                </div>

                                <div class="feature-item">
                                    <v-icon :color="index % 2 === 0 ? '#0d2c6d' : '#fdbd29'"
                                        class="feature-icon">mdi-database</v-icon>
                                    <div class="feature-text">
                                        <span class="feature-value">{{ item.storage }}GB</span>
                                        <span class="feature-label">אחסון</span>
                                    </div>
                                </div>

                                <div class="feature-item">
                                    <v-icon :color="index % 2 === 0 ? '#0d2c6d' : '#fdbd29'"
                                        class="feature-icon">mdi-broadcast</v-icon>
                                    <div class="feature-text">
                                        <span class="feature-value">{{ item.channels }}</span>
                                        <span class="feature-label">ערוצים</span>
                                    </div>
                                </div>

                                <div class="feature-item">
                                    <v-icon :color="index % 2 === 0 ? '#0d2c6d' : '#fdbd29'"
                                        class="feature-icon">mdi-account-multiple</v-icon>
                                    <div class="feature-text">
                                        <!-- נטען רק בלחיצה, לא בכניסה לדף -->
                                        <span v-if="ivrsCount[item._id] !== undefined" class="feature-value">{{ ivrsCount[item._id] }}</span>
                                        <v-btn v-else x-small text color="#0d2c6d" class="count-btn"
                                            :loading="!!ivrsCountLoading[item._id]" @click.stop="loadIvrsCount(item)">הצג</v-btn>
                                        <span class="feature-label">מערכות בחבילה</span>
                                    </div>
                                </div>
                            </div>

                            <div class="plan-actions">
                                <div class="visibility-status">
                                    <v-chip small :color="item.show_to_user ? 'success' : 'error'" text-color="white"
                                        class="status-chip">
                                        <v-icon small left>{{ item.show_to_user ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                                        {{ item.show_to_user ? 'מוצג' : 'מוסתר' }}
                                    </v-chip>
                                </div>

                                <div class="action-buttons">
                                    <v-btn icon small class="action-btn edit-btn" @click="openEditDialog(item)"
                                        :color="index % 2 === 0 ? '#0d2c6d' : '#fdbd29'">
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>

                                    <v-btn icon small class="action-btn delete-btn" @click="confirmDelete(item)"
                                        color="error">
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </v-card>
                </v-col>
            </v-row>

            <div v-if="plans.length === 0 && !progressShow" class="no-plans">
                <v-icon size="64" color="grey lighten-1">mdi-package-variant</v-icon>
                <p>אין חבילות להצגה</p>
                <v-btn color="primary" @click="openCreateDIalog">הוסף חבילה חדשה</v-btn>
            </div>
            </div>

            <!-- נטען רק בפעם הראשונה שפותחים את הלשונית -->
            <PlansStatsComp v-if="statsOpened" v-show="view === 'stats'" />
        </v-card>

        <!-- Loading Indicator -->
        <v-overlay :value="progressShow" v-if="progressShow" absolute class="loading-overlay">
            <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
        </v-overlay>

        <!-- Confirmation Dialog -->
        <v-dialog v-model="confirmDialog" max-width="400">
            <v-card>
                <v-card-title class="headline">מחיקת חבילה</v-card-title>
                <v-card-text>
                    האם אתה בטוח שברצונך למחוק את החבילה "{{ planToDelete.name }}"?
                    <div v-if="ivrsCountLoading[planToDelete._id]" class="warning-text">
                        בודק כמה מערכות משתמשות בחבילה...
                    </div>
                    <div v-else-if="ivrsCount[planToDelete._id] > 0" class="warning-text">
                        <v-icon color="warning">mdi-alert</v-icon>
                        שים לב: יש {{ ivrsCount[planToDelete._id] }} מערכות בחבילה זו.
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="confirmDialog = false">ביטול</v-btn>
                    <v-btn color="error" text @click="executeDelete" :disabled="!!ivrsCountLoading[planToDelete._id]">מחק</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Edit/Add Dialog -->
        <PlansAddEditDialog v-model="editPlanDialog" v-if="editPlanDialog" :planToEdit="planToEdit" :agents="agents"
            :formTitle="formTitle" @planEdited="planEditedSaved" @planCreated="newPlanSaved" />

        <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
    </v-container>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'
import Util from '@/util/utils.js'
import PlansAddEditDialog from '@/components/admin/dialogs/PlansAddEditDialog'
import PlansStatsComp from '@/components/admin/PlansStatsComp'

export default {
    components: {
        SnackBar,
        PlansAddEditDialog,
        PlansStatsComp
    },
    data: () => ({
        progressShow: false,
        snackbar: false,
        snackbarColorBt: "green",
        snacbarText: "",
        plans: [],
        view: 'plans',        // 'plans' | 'stats'
        statsOpened: false,   // הלשונית נטענת רק כשפותחים אותה
        agents: [],           // [{ line_number, name }] - לשדה "שייכות" ולתגית בכרטיס
        planToEdit: {},
        planToDelete: {},
        formTitle: "",
        editPlanDialog: false,
        confirmDialog: false,
        ivrsCount: {},        // planId -> כמה מערכות בחבילה (נטען בלחיצה)
        ivrsCountLoading: {}  // planId -> נטען עכשיו
    }),
    methods: {
        showStats() {
            this.view = 'stats';
            this.statsOpened = true;
        },
        async getAgents() {
            try {
                const token = localStorage.getItem("token");
                const res = await fetch(process.env.VUE_APP_BASE_URL + `/admin_api/agents_list`, ApiServices.requestOptions("GET", "", token));
                if (res.status === 200) this.agents = await res.json();
            } catch (error) {
                console.error(error);
            }
        },
        // שם הסוכן לתגית: מהרשימה העדכנית, ואם אין - מה שהשרת צירף, ואם אין - מספר הקו
        agentName(item) {
            const agent = this.agents.find(a => a.line_number === item.belong_to_agent);
            return (agent && agent.name) || item.agent_name || item.belong_to_agent;
        },
        async getAllPlans() {
            try {
                this.progressShow = true;
                let token = localStorage.getItem("token");
                let api = process.env.VUE_APP_BASE_URL + `/admin_api/get_plans_for_edit`;
                const res = await fetch(api, ApiServices.requestOptions("GET", "", token));
                const jsonObject = await res.json();
                if (res.status >= 400) {
                    this.showSnackBar("שגיאה בקבלת נתונים", "red");
                } else if (res.status === 200) {
                    this.plans = jsonObject;
                }
            } catch (error) {
                this.showSnackBar("Error get files: " + error, "red");
            } finally {
                this.progressShow = false;
            }
        },

        openEditDialog(item) {
            this.planToEdit = item;
            this.formTitle = "ערוך חבילה";
            this.editPlanDialog = true;
        },

        openCreateDIalog() {
            this.formTitle = "הוסף חבילה";
            this.planToEdit = {};
            this.editPlanDialog = true;
        },

        // כמה מערכות משתמשות בחבילה - רק כשמבקשים, ולכל חבילה פעם אחת
        async loadIvrsCount(item) {
            if (this.ivrsCount[item._id] !== undefined || this.ivrsCountLoading[item._id]) return;
            this.$set(this.ivrsCountLoading, item._id, true);
            try {
                const token = localStorage.getItem("token");
                const api = process.env.VUE_APP_BASE_URL + `/admin_api/plan_ivrs_count?planId=${item._id}`;
                const res = await fetch(api, ApiServices.requestOptions("GET", "", token));
                if (res.status === 200) {
                    const { count } = await res.json();
                    this.$set(this.ivrsCount, item._id, count);
                } else {
                    this.showSnackBar("שגיאה בקבלת מספר המערכות", "red");
                }
            } catch (error) {
                this.showSnackBar("שגיאה בקבלת מספר המערכות", "red");
            } finally {
                this.$set(this.ivrsCountLoading, item._id, false);
            }
        },

        confirmDelete(item) {
            this.planToDelete = item;
            this.confirmDialog = true;
            // האזהרה על מערכות בחבילה: נטענת רק לחבילה שמוחקים
            this.loadIvrsCount(item);
        },

        async executeDelete() {
            this.confirmDialog = false;
            await this.deletePlan(this.planToDelete);
        },

        showSnackBar(message, color) {
            this.snacbarText = message;
            this.snackbarColorBt = color;
            this.snackbar = true;
        },

        planEditedSaved(item, text, color) {
            this.showSnackBar(text, color);
            if (item === "") {
                return;
            }
            const index = this.plans.findIndex(plan => plan._id === item._id);
            if (index !== -1) {
                Object.assign(this.plans[index], item);
            }
        },

        newPlanSaved(item, text, color) {
            this.showSnackBar(text, color);
            if (item === "") {
                return;
            }
            this.plans.push(item);
        },

        async deletePlan(item) {
            try {
                this.progressShow = true;
                let token = localStorage.getItem("token");
                const planJSON = JSON.stringify({ plan: item });
                let api = process.env.VUE_APP_BASE_URL + `/admin_api/delete_plan`;
                const res = await fetch(api, ApiServices.requestOptions("DELETE", planJSON, token));
                const jsonObject = await res.json();

                if (res.status >= 400) {
                    this.showSnackBar("שגיאה במחיקת החבילה: " + jsonObject.message, "red");
                } else if (res.status === 200) {
                    this.showSnackBar("החבילה נמחקה בהצלחה!", "green");
                    // Use splice to remove the item at the specified index
                    const index = this.plans.findIndex(plan => plan._id === item._id);
                    if (index !== -1) {
                        this.plans.splice(index, 1);
                    }
                }
            } catch (error) {
                this.showSnackBar("Error get files: " + error, "red");
            } finally {
                this.progressShow = false;
            }
        }
    },
    mounted() {
        this.getAllPlans();
        this.getAgents();
    },
}
</script>

<style scoped>
.admin-plans-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0px 16px;
    direction: rtl;
}

.admin-card {
    border-radius: 12px;
    overflow: hidden;
    background-color: white;
    margin: 16px 16px 16px 16px;
    padding: 16px 16px 16px 16px;
}

.admin-header {
    padding: 10px 24px 24px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.admin-title-section {
    display: flex;
    flex-direction: column;
}

.admin-title {
    font-size: 1.8rem;
    font-weight: 700;
    color: #333;
    margin: 0;
}

.admin-subtitle {
    font-size: 1rem;
    color: #666;
    margin-top: 4px;
}

.add-plan-btn {
    background: linear-gradient(0deg, rgba(255, 185, 26, 1) 0%, rgba(255, 185, 26, 0.8) 100%);
    color: #0d2c6d !important;
    font-weight: 600;
    border-radius: 8px;
    padding: 0 20px !important;
    height: 44px;
}

/* מעבר בין החבילות למצב החבילות - אותו עיצוב כמו בדף הסקרים */
.plans-seg {
    display: inline-flex;
    background: #e9edf5;
    border-radius: 12px;
    padding: 4px;
    gap: 2px;
    margin: 0 24px 16px;
}

.plans-seg__btn {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 7px 16px;
    border-radius: 9px;
    font: 500 14px 'Heebo', sans-serif;
    color: #3d5488;
    background: none;
    border: 0;
    cursor: pointer;
    transition: background-color .15s, color .15s;
}

.plans-seg__btn:hover {
    color: #0d2c6d;
}

.plans-seg__btn.is-active {
    background: #fff;
    color: #0d2c6d;
    font-weight: 700;
    box-shadow: 0 1px 2px rgba(13, 44, 109, .12);
}

.plans-seg__btn:focus-visible {
    outline: 2px solid #ffb91a;
    outline-offset: 2px;
}

.plans-seg__count {
    font-variant-numeric: tabular-nums;
    font-size: 12px;
    font-weight: 700;
    color: #6b7690;
}

.plans-seg__btn.is-active .plans-seg__count {
    color: #0d2c6d;
}

.plans-count {
    padding: 10px 24px 30px;
    margin-top: 16px;
    color: #666;
    font-size: 0.9rem;
}

.plan-card {
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.3s ease;
    height: 100%;
    display: flex;
    flex-direction: column;
    width: 300px;
    max-width: 100%;
}

.plan-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1) !important;
}

.plan-card-hidden {
    opacity: 0.7;
}

.ravkol-only-card {
    border: 2px solid #9c27b0;
}

.plan-header {
    padding: 20px;
    text-align: center;
    color: white;
    position: relative;
}

.primary-plan {
    background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%);
}

.secondary-plan {
    background: linear-gradient(135deg, #fdbd29 0%, #ffcf5c 100%);
    color: #0d2c6d;
}

.plan-name {
    font-size: 1.4rem;
    font-weight: 700;
    margin-bottom: 12px;
}

.plan-price {
    display: flex;
    align-items: baseline;
    justify-content: center;
}

.currency {
    font-size: 1.2rem;
    font-weight: 600;
    margin-right: 4px;
}

.amount {
    font-size: 2.5rem;
    font-weight: 700;
    line-height: 1;
}

/* חבילה של סוכן: תגית קטנה בכותרת הכרטיס, קריאה גם על כותרת כחולה וגם על צהובה */
.agent-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-top: 10px;
    padding: 2px 10px;
    border-radius: 999px;
    background: #ffffff;
    color: #0d2c6d;
    border: 1px solid rgba(13, 44, 109, 0.2);
    font-size: 0.78rem;
    font-weight: 500;
}

.agent-badge .v-icon {
    color: #0d2c6d !important;
}

.ravkol-badge {
    position: absolute;
    top: 8px;
    right: 8px;
}

.ravkol-chip {
    font-size: 0.7rem;
    height: 24px;
}

.plan-body {
    padding: 20px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    background-color: white;
}

.plan-features {
    flex-grow: 1;
}

.feature-item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.feature-item:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
}

.feature-icon {
    margin-left: 16px;
    font-size: 24px;
}

.feature-text {
    display: flex;
    flex-direction: column;
}

.feature-value {
    font-size: 1.2rem;
    font-weight: 700;
    color: #333;
}

.feature-label {
    font-size: 0.9rem;
    color: #666;
}

.plan-actions {
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.visibility-status {
    display: flex;
    align-items: center;
}

.status-chip {
    font-size: 0.8rem;
}

.action-buttons {
    display: flex;
    gap: 8px;
}

.action-btn {
    transition: all 0.2s ease;
}

.action-btn:hover {
    transform: scale(1.1);
}

.no-plans {
    padding: 48px 24px;
    text-align: center;
    color: #666;
}

.no-plans p {
    margin: 16px 0;
    font-size: 1.1rem;
}

.warning-text {
    margin-top: 16px;
    color: #ff9800;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
}

.loading-overlay {
    z-index: 999;
    background-color: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(2px);
}

@media (max-width: 600px) {
    .admin-header {
        flex-direction: column;
        align-items: flex-start;
    }

    .add-plan-btn {
        width: 100%;
    }

    .plan-header {
        padding: 16px;
    }

    .plan-name {
        font-size: 1.2rem;
    }

    .amount {
        font-size: 2rem;
    }

    .plan-body {
        padding: 16px;
    }
}
</style>